<div class="container">
    <div class="col">
        <ng-container *ngIf="configTheme === 'swimbird' || configTheme === 'naps'">
            <h1>The page you are looking for is missing</h1>
            <p>
                If you feel that this is because of an error please contact us at
                <a href="mailto:clientservice@swimbird.se">clientservice@swimbird.se</a>
                and we will help you out as soon as possible. We are truly sorry for any
                inconvenience.
            </p>
        </ng-container>
        <ng-container *ngIf="configTheme === 'carnegie'">
            <h1>The page you are looking for is missing</h1>
            <p>
                If you feel that this is because of an error please contact us and we will
                help you out as soon as possible. We are truly sorry for any
                inconvenience.
            </p>
        </ng-container>
    </div>
</div>
